const runtime=(window._env_)||{};
export const KEYCLOAK_REALM=runtime.REACT_APP_KEYCLOAK_REALM||process.env.REACT_APP_KEYCLOAK_REALM||"KEYCLOAK_REALM";
export const KEYCLOAK_URL=runtime.REACT_APP_KEYCLOAK_URL||process.env.REACT_APP_KEYCLOAK_URL||"KEYCLOAK_URL";
export const KEYCLOAK_CLIENTID=runtime.REACT_APP_KEYCLOAK_CLIENTID||process.env.REACT_APP_KEYCLOAK_CLIENTID||"KEYCLOAK_CLIENTID";